export default "__VITE_ASSET__BNu3M2VB__"